import { render, staticRenderFns } from "./OfferedIcon.vue?vue&type=template&id=3ab43c38&scoped=true&"
import script from "./OfferedIcon.vue?vue&type=script&lang=js&"
export * from "./OfferedIcon.vue?vue&type=script&lang=js&"
import style0 from "./OfferedIcon.vue?vue&type=style&index=0&id=3ab43c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab43c38",
  null
  
)

export default component.exports